import { Input, Select, DatePicker } from 'antd';
import { TagOutlined, UserOutlined, FlagOutlined } from '@ant-design/icons';
import type { Dayjs } from 'dayjs';
import { STATUS_OPTIONS } from './status';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useResetOnBreakpoint } from '../../components/filters/useResetOnBreakpoint';
import TagFilter from './TagFilter';
import MobileFilterBar from './MobileFilterBar';
import type { FilterBarProps } from './filter.types';

type Range = [Dayjs | null, Dayjs | null] | null;

/** 文章列表的篩選：手機改用可收合面板，桌機維持原本一列工具列。 */
export default function FilterBar(props: FilterBarProps) {
  useResetOnBreakpoint(() => {
    props.onTitle('');
    props.onCategory(undefined);
    props.onAuthor(undefined);
    props.onTag(undefined);
    props.onStatus(undefined);
    props.onDateRange(undefined, undefined);
  });
  return useIsMobile() ? <MobileFilterBar {...props} /> : <DesktopFilterBar {...props} />;
}

/** 桌機篩選工具列（包在白卡片中）。 */
function DesktopFilterBar({
  categories,
  authors,
  onTitle,
  onCategory,
  onAuthor,
  onTag,
  onStatus,
  onDateRange,
}: FilterBarProps) {
  const handleRange = (value: Range) => {
    const from = value?.[0]?.startOf('day').valueOf();
    const to = value?.[1]?.endOf('day').valueOf();
    onDateRange(from, to);
  };
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 rounded-xl border border-black/5 bg-white p-3 shadow-sm">
      <Input.Search
        placeholder="搜尋標題"
        allowClear
        style={{ width: 240 }}
        onSearch={onTitle}
      />
      <Select
        placeholder="分類"
        allowClear
        suffixIcon={<TagOutlined />}
        style={{ width: 150 }}
        onChange={onCategory}
        options={categories}
      />
      <Select
        placeholder="作者"
        allowClear
        showSearch
        optionFilterProp="label"
        suffixIcon={<UserOutlined />}
        style={{ width: 150 }}
        onChange={onAuthor}
        options={authors}
      />
      <TagFilter onChange={onTag} />
      <Select
        placeholder="狀態"
        allowClear
        suffixIcon={<FlagOutlined />}
        style={{ width: 130 }}
        onChange={onStatus}
        options={STATUS_OPTIONS}
      />
      <DatePicker.RangePicker
        allowClear
        placeholder={['發佈日（起）', '發佈日（迄）']}
        onChange={handleRange}
      />
    </div>
  );
}
